import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import { tID } from '../../utils/utils'
import { ConfirmationModal } from '../confirmationModal/ConfirmationModal'
import { ProviderCalendarEditSessionModalityContent } from '../providerCalendarEditSessionModalityContent/ProviderCalendarEditSessionModalityContent'

export type ProviderCalendarEditSessionModalityModalProps = {
  visible: boolean
  onRequestClose: () => void
  onConfirmationButtonPress: () => void
  confirmButtonLoading?: boolean
  confirmButtonDisabled?: boolean
  closeOnScrim?: boolean
  clientFirstName: string
  clientLastName: string
  startDate: string
  endDate: string
  timeZone: string
  upcomingAppointmentIds?: number[]
  selectedModality: string
  setSelectedModality: (value: string) => void
  isLoadingClientBookingDetails: boolean
  modalityOptions: { label: string; value: string }[]
}

export const ProviderCalendarEditSessionModalityModal: FunctionComponent<
  ProviderCalendarEditSessionModalityModalProps
> = ({
  visible,
  onRequestClose,
  onConfirmationButtonPress,
  confirmButtonLoading,
  confirmButtonDisabled,
  closeOnScrim = false,
  clientFirstName,
  clientLastName,
  startDate,
  endDate,
  timeZone,
  upcomingAppointmentIds,
  selectedModality,
  setSelectedModality,
  isLoadingClientBookingDetails,
  modalityOptions,
}) => {
  return (
    <ConfirmationModal
      testID={tID('ProviderCalendarEditSessionModalityModal')}
      visible={visible}
      modalTitle={<FormattedMessage defaultMessage='Edit modality' description='Title for the edit modality modal' />}
      modalContents={
        <ProviderCalendarEditSessionModalityContent
          clientFirstName={clientFirstName}
          clientLastName={clientLastName}
          startDate={startDate}
          endDate={endDate}
          timeZone={timeZone}
          upcomingAppointmentIds={upcomingAppointmentIds}
          selectedModality={selectedModality}
          setSelectedModality={setSelectedModality}
          isLoadingClientBookingDetails={isLoadingClientBookingDetails}
          modalityOptions={modalityOptions}
        />
      }
      confirmationButtonText={
        <FormattedMessage defaultMessage='Save' description='Save button in edit modality modal' />
      }
      cancelButtonText={<FormattedMessage defaultMessage='Cancel' description='Cancel button in edit modality modal' />}
      onConfirmationButtonPress={onConfirmationButtonPress}
      onRequestClose={onRequestClose}
      confirmButtonLoading={confirmButtonLoading}
      confirmButtonDisabled={confirmButtonDisabled}
      showCloseIcon
      closeOnScrim={closeOnScrim}
      singleLineButtons
    />
  )
}
